import { MutableRefObject, createContext } from 'react';
import { MainSubEdiTableDispatchType, IMainSubEdiTablePayload } from '../interface';
import { FormInstance } from 'antd/lib/form';

export interface IBaseEdiTableContext {
  dataSource?: any[];
  forms?: MutableRefObject<(FormInstance | undefined)[][]>;
}
export interface IEdiTableContext extends IBaseEdiTableContext {
  dispatchEdiTable: (
    type: MainSubEdiTableDispatchType,
    payload: IMainSubEdiTablePayload,
  ) => void;
}
export default createContext<IEdiTableContext>({
  dispatchEdiTable: () => {},
});